"use client";

import React from "react";

// components
import DataTable from "../../../component/element/table";
import Button from "../../../component/element/forms/Button";
import EditService from "../edit";
import { Switch } from "antd";
import ItemAction from "../../../component/ui/action/ItemAction";

// dispatch and types
import { useAppDispatch, useAppSelector } from "../../../store";
import {
  get_service,
  delete_package,
  update_status,
} from "../../../services/apis/services";
import type { ColumnDef } from "@tanstack/react-table";
import type { ISimpleData } from "../../../store/types/misc";

// constants
import { useNavigate, useParams } from "react-router-dom";
import { FaArrowLeftLong, FaRegPenToSquare } from "react-icons/fa6";

const ViewService: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const service = useAppSelector(({ service }) => service.service);
  const [show, showSet] = React.useState<string>("");

  const onLoad = React.useCallback(() => {
    if (id) get_service(dispatch, id);
  }, [dispatch, id]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);
  const colums: ColumnDef<ISimpleData>[] = [
    {
      accessorKey: "name",
      header: "Name",
      cell: ({ getValue }) => {
        const name = getValue() as string;
        return name;
      },
    },
    {
      accessorKey: "id",
      header: "Action",
      cell: ({ getValue }) => {
        const id = getValue() as string;
        return (
          <ItemAction
            show_view={false}
            show_edit={false}
            onView={() => null}
            onEdit={() => null}
            onDelete={() => delete_package(dispatch, id)}
          />
        );
      },
    },
  ];

  return (
    <div>
      <div className="w-full flex justify-end mb-6 gap-4">
        <Button
          title="Edit Service"
          type="button"
          children={<FaRegPenToSquare className="mr-2" />}
          onClick={() => {
            if (id) showSet(id);
          }}
        />
        <Button
          title="Back"
          type="button"
          onClick={() => navigate(-1)}
          children={<FaArrowLeftLong className="mr-2" />}
          className="px-4"
        />
      </div>
      <div className="grid lg:grid-cols-3 items-start gap-4">
        <div className="grid lg:col-span-2 bg-white shadow-sm rounded-xl overflow-hidden ">
          <div className="shadow-sm">
            <img
              src={service?.image || "/placeholder.svg"}
              alt={service?.name}
              className="w-full h-[40vh] object-cover"
            />
          </div>
          <div className="p-6">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-xl font-bold text-gray-800">
                {service?.name}
              </h2>
              <div className="flex items-center space-x-2">
                <span className="text-sm text-gray-500">
                  {service?.status === "1" ? "Active" : "Inactive"}
                </span>
                <Switch
                  checked={service?.status === "1" ? true : false}
                  onClick={() => {
                    if (id) update_status(dispatch, id);
                  }}
                />
              </div>
            </div>
            <hr className="text-gray-200" />
            <div
              className="text-base text-gray-700 mt-4"
              dangerouslySetInnerHTML={{ __html: service?.description || "" }}
            />
          </div>
        </div>
        <div>
          <h3 className="text-lg font-semibold text-gray-800 mb-4">Packages</h3>
          <div className="overflow-hidden">
            <DataTable columns={colums} data={service?.packages || []} />
          </div>
        </div>
      </div>

      {show && (
        <EditService
          show={show ? true : false}
          id={show}
          onCancel={() => showSet("")}
        />
      )}
    </div>
  );
};

export default ViewService;
